module.exports = __webpack_public_path__ + "media/images/icons/robot-white-7bf4ec8a724a879e14a3900c90ae2598.svg";